import type { CategorySlug } from "@/api/types";

export interface MarketplaceSearch {
  q: string;
  category?: CategorySlug;
  subcategory?: string;
  subscope?: string;
  gameType?: string;
  publishedWithin?: 7 | 30 | 90;
  price: "all" | "free" | "paid" | "sale";
  minRating: 0 | 3 | 4;
  sort: "popular" | "trending" | "newest" | "price-asc" | "price-desc" | "rating";
}

const DEFAULTS: MarketplaceSearch = { q: "", price: "all", minRating: 0, sort: "popular" };

/** Builds a complete `/marketplace` search object for a link, so callers only state what they scope. */
export function marketplaceSearch(scope: Partial<MarketplaceSearch> = {}): MarketplaceSearch {
  return { ...DEFAULTS, ...scope };
}

/**
 * `/marketplace` is a discovery surface only while it is unscoped. Any search,
 * category, game type or filter turns it into a focused product list.
 */
export function isDiscoveryView(search: MarketplaceSearch) {
  return (
    !search.q &&
    !search.category &&
    !search.gameType &&
    !search.publishedWithin &&
    // Trending is a curated ranking, not a default ordering — unlike every other
    // sort value it scopes the page to a product list of its own.
    search.sort !== "trending" &&
    search.price === "all" &&
    search.minRating === 0
  );
}
